import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/v1`,
  withCredentials: true,
  timeout: 20000,
  headers: { "X-Requested-With": "BIZII" },
});

export function apiError(error) {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === "object" && !Array.isArray(detail)) {
    return {
      status,
      code: detail.code || "error",
      message: detail.message || "Something went wrong. Please try again.",
      errors: Array.isArray(detail.errors) ? detail.errors : [],
      retryAfter: detail.retry_after,
    };
  }
  if (typeof detail === "string") return { status, code: "error", message: detail, errors: [] };
  if (Array.isArray(detail)) {
    return { status: 422, code: "validation_error", message: detail.map((d) => d?.msg).filter(Boolean).join(" "), errors: [] };
  }
  if (error?.code === "ECONNABORTED") return { status, code: "timeout", message: "The request timed out. Please try again.", errors: [] };
  return { status, code: "network", message: "Unable to reach BIZII right now. Check your connection and try again.", errors: [] };
}
